import React, {Component} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {Input, Button, CircularProgress} from '@material-ui/core';
import {Edit, Save, Check, Close} from '@material-ui/icons';

//button states
const EDITING = 'editing';
const SUBMITTING = 'submitting';
const SUCCESS = 'success';
const ERROR = 'error';
const DEFAULT = 'default';

class ToggleEditGroup extends Component {
  state = {
    inputState: DEFAULT,
  };

  onUpdate = async () => {
    if (!this.props.shouldUpdate()) {
      this.setState({inputState: DEFAULT});
      this.props.setChildrenEditable(false);
      return;
    }

    this.setState({inputState: SUBMITTING});
    this.props.setChildrenEditable(false);

    try {
      await this.props.onUpdate();

      this.setState({inputState: SUCCESS});

      setTimeout(() => {
        this.setState({inputState: DEFAULT});
      }, 3000);
    } catch {
      this.setState({inputState: ERROR});

      setTimeout(() => {
        this.setState({inputState: EDITING});
      }, 3000);
    }
  };

  getButtonPropsFromState = () => {
    // Rebranding 2026 · icona antracite (no MUI secondary blu), palette ivory
    const iconProps = {
      fontSize: 'small',
      style: {color: '#1F2125'},
    };

    const {inputState} = this.state;

    if (inputState === ERROR) {
      return {
        icon: <Close {...iconProps} style={{color: '#B0463C'}} />,
        style: {background: '#F9E9E5', border: '1px solid #F0CFC8'},
      };
    }

    if (inputState === SUCCESS) {
      return {
        icon: <Check {...iconProps} style={{color: '#3B8B6A'}} />,
        style: {background: '#E8F2EC', border: '1px solid #CFE6DA'},
      };
    }

    if (inputState === SUBMITTING) {
      return {
        icon: <Spinner />,
        disabled: true,
        style: {background: '#F4ECD8', border: '1px solid #F1E4C4'}
      };
    }

    if (inputState === EDITING) {
      return {
        icon: <Save {...iconProps} />,
        style: {background: '#C9A961', border: '1px solid #A88845'},
        onClick: () => this.onUpdate()
      };
    }

    return {
      icon: <Edit {...iconProps} />,
      style: {background: '#FAF4E6', border: '1px solid #F1E4C4'},
      onClick: () => {
        this.setState({inputState: EDITING});
        this.props.setChildrenEditable(true);
      },
    };
  };

  render() {
    const {icon, ...buttonProps} = this.getButtonPropsFromState();
    const isEditing = this.state.inputState === EDITING;
    return (
      <Row>
        {this.props.children}
        <IconButton {...buttonProps}>{icon}</IconButton>
      </Row>
    );
  }
}

export default ToggleEditGroup;

ToggleEditGroup.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  setChildrenEditable: PropTypes.func.isRequired,
  shouldUpdate: PropTypes.func.isRequired,
};

const Row = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const IconButton = styled(Button).attrs({
  variant: 'contained',
  disableElevation: true,
  className: 'gc-edit-toggle',
})`
  /* Rebranding 2026 · box 40x40 sempre, palette Ivory */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  min-width: 40px;
  padding: 0;
  margin: 0 0 0 8px;
  border-radius: 8px;
  box-shadow: none;
  transition: transform 100ms ease, box-shadow 200ms ease;

  &:hover {
    box-shadow: 0 2px 6px rgba(31,33,37,0.08);
    transform: translateY(-1px);
  }
  &:active { transform: translateY(0); }
`;

const Spinner = styled(CircularProgress).attrs({
  size: 16,
})`
  color: var(--gc-antracite, #1F2125);
`;
